import { COLOR } from '@ordermentum/ui-constants/ui/color';
import { standard } from './standard';

export const lozengeInput = {
  ...standard,
  height: {
    ...standard.height,
    default: '2rem',
  },
  padding: `0.25rem 0.5rem`,
  width: {
    ...standard.width,
    default: '100%',
  },
  boxShadow: {
    active: 'none',
    inActive: 'none',
    error: 'none',
  },
  border: {
    active: 'none',
    inActive: 'none',
    error: 'none',
  },
  color: {
    active: 'initial',
    inActive: COLOR.BLACK,
    error: 'initial',
  },
  fontSize: '14px',
  fontWeight: 400,
  cursor: {
    focus: 'text',
    active: 'text',
    inActive: 'not-allowed',
    readOnly: 'text',
    error: 'text',
  },
  extras: {
    ...standard.extras,
    [`&:focus`]: {
      outline: 'none',
      outlineOffset: '0',
    },
  },
};
